module.exports = __webpack_public_path__ + "static/event_1-da537c09f19ee469cdc718345354ea72.png";